export const Laugh = ({
  fill = "#a5b5af",
  width = "25.999",
  height = "25.999",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.999 25.999"
    {...props}
  >
    <path
      id="Emoji"
      d="M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,24.817A11.818,11.818,0,1,1,24.817,13,11.818,11.818,0,0,1,13,24.817ZM18.509,14l-.966.162A27.968,27.968,0,0,1,8.027,14.1L7.5,14.007a.845.845,0,0,0-.987.68.865.865,0,0,0,.03.425,6.795,6.795,0,0,0,12.914,0,.852.852,0,0,0-.544-1.078.884.884,0,0,0-.4-.032ZM13,18.583A5.612,5.612,0,0,1,7.87,15.274a29.121,29.121,0,0,0,9.868.05l.39-.065A5.615,5.615,0,0,1,13,18.583Zm1.253-9.646a2.8,2.8,0,0,1,5.182,0,.593.593,0,0,1-1.1.443,1.61,1.61,0,0,0-2.99,0,.59.59,0,1,1-1.093-.443Zm-7.681,0a2.8,2.8,0,0,1,5.182,0,.593.593,0,0,1-1.1.443,1.61,1.61,0,0,0-2.99,0,.59.59,0,1,1-1.093-.443Z"
      fill={fill}
    />
  </svg>
);

export const Smile = ({
  fill = "#a5b5af",
  width = "25.999",
  height = "25.999",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.999 25.999"
    {...props}
  >
    <path
      id="Emoji"
      d="M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,24.817A11.818,11.818,0,1,1,24.817,13,11.818,11.818,0,0,1,13,24.817ZM7.091,8.863a1.182,1.182,0,1,1,1.182,1.182A1.181,1.181,0,0,1,7.091,8.863Zm9.454,0a1.182,1.182,0,1,1,1.182,1.182A1.181,1.181,0,0,1,16.545,8.863Zm2.91,6.243a6.795,6.795,0,0,1-12.914,0,.59.59,0,0,1,1.1-.431.509.509,0,0,1,.021.062,5.613,5.613,0,0,0,10.674,0,.59.59,0,0,1,1.12.369Z"
      fill={fill}
    />
  </svg>
);

export const Face = ({
  fill = "#a5b5af",
  width = "25.999",
  height = "25.999",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.999 25.999"
    {...props}
  >
    <path
      id="Emoji"
      d="M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,24.817A11.818,11.818,0,1,1,24.817,13,11.818,11.818,0,0,1,13,24.817Zm-4.432-12.7a1.182,1.182,0,1,1,1.182-1.182A1.181,1.181,0,0,1,8.568,12.113Zm10.045-1.182a1.182,1.182,0,1,1-1.182-1.182A1.181,1.181,0,0,1,18.613,10.931Zm-.591,6.8a.593.593,0,0,1-.591.591H8.568a.591.591,0,0,1,0-1.182h8.863A.593.593,0,0,1,18.022,17.726Z"
      fill={fill}
    />
  </svg>
);

export const Sad = ({
  fill = "#a5b5af",
  width = "25.999",
  height = "25.999",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.999 25.999"
    {...props}
  >
    <path
      id="Emoji"
      d="M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,24.817A11.818,11.818,0,1,1,24.817,13,11.818,11.818,0,0,1,13,24.817Zm6.352-7.386a.6.6,0,1,1-1.034.591,6.115,6.115,0,0,0-10.636,0,.593.593,0,1,1-1.028-.591,7.3,7.3,0,0,1,12.7,0ZM7.091,8.272A1.182,1.182,0,1,1,8.272,9.454,1.181,1.181,0,0,1,7.091,8.272Zm9.454,0a1.182,1.182,0,1,1,1.182,1.182A1.181,1.181,0,0,1,16.545,8.272Z"
      fill={fill}
    />
  </svg>
);

export const Angry = ({
  fill = "#a5b5af",
  width = "25.999",
  height = "25.999",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.999 25.999"
    {...props}
  >
    <path
      id="Emoji"
      d="M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,24.817A11.818,11.818,0,1,1,24.817,13,11.818,11.818,0,0,1,13,24.817ZM20.072,19.2a.592.592,0,0,1-1.146.3,6.122,6.122,0,0,0-11.853,0,.591.591,0,0,1-.573.449.613.613,0,0,1-.148-.018.592.592,0,0,1-.428-.718s0-.006,0-.009a7.306,7.306,0,0,1,14.146,0ZM5.613,9.75a.59.59,0,1,1,1.093-.443,2.006,2.006,0,0,0,3.723,0,.591.591,0,0,1,1.09.443,3.188,3.188,0,0,1-5.906,0Zm14.772,0a3.191,3.191,0,0,1-5.909,0,.59.59,0,1,1,1.093-.443,2.006,2.006,0,0,0,3.723,0,.592.592,0,0,1,1.093.443Z"
      fill={fill}
    />
  </svg>
);

// Lowercase versions for backwards compatibility
export const laugh = <Laugh />;
export const smile = <Smile />;
export const face = <Face />;
export const sad = <Sad />;
export const angry = <Angry />;
